module.exports = __webpack_public_path__ + "img/image 12.e9d90c07.png";